<script>
export default {
	created() {
		let url = 'https://daalinge.gitee.io/kuxmusic_pc.com'
        window.location.replace(url)
	}
}
</script>